import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { RoomLayoutsModel } from '../../rooms';

export const MAX_ON_BEHALF_PERSONS = 2;

export type RoomBookingFormGroupModel<T> = FormGroup<{
  [K in keyof T]: FormControl<T[K]>;
}>;

export interface RoomBookingFormValueModel {
  eventName: string;
  startDate: Date;
  endDate: Date;
  startHour: Date | null;
  endHour: Date | null;
  wbsCode: string | null;
  costCenter: string;
  numberOfPeople: number;
  roomLayoutUUID: RoomLayoutsModel | null;
  onBehalfEmails: (string | null)[];
  cecOnSite: boolean | null;
  hcpOnSite: boolean | null;
  moreThan20Externals: boolean | null;
  customSetupTimeBeforeM: number | null;
  customSetupTimeBeforeH: number | null;
  customSetupTimeAfterM: number | null;
  customSetupTimeAfterH: number | null;
  additionalInfo: string | null;
}

export type OnBehalfFormArrayModel = FormArray<FormControl<string | null>>;

export type RoomBookingFormModel = FormGroup<
  RoomBookingFormGroupModel<
    Omit<RoomBookingFormValueModel, 'onBehalfEmails'>
  >['controls'] & {
    onBehalfEmails: OnBehalfFormArrayModel;
  }
>;
